export const SET_VENDORTIMEDEVENTS = 'SET_VENDORTIMEDEVENTS';
export const GET_VENDORTIMEDEVENTS = 'GET_VENDORTIMEDEVENTS';
